// 组件对象，大写
import uploadAttachment from './uploadAttachment.vue'
export default uploadAttachment
